const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAced(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 177.492,
    height: 64.849,
    viewBox: "0 0 177.492 64.849",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Raggruppa 4785"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Raggruppa 4785"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "A",
    d: "m839.172 490.959 15.554-38.636h6.1l15.5 38.636h-7.969l-11.981-31.711h2.748l-12.146 31.711zm8.244-7.2v-6.265h20.774v6.265z",
    transform: "translate(-792.532 -451.224)",
    style: {
      fill: "#04051D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "C",
    d: "M978.532 515.586a14.713 14.713 0 0 1-7.309-1.814 13.963 13.963 0 0 1-5.111-19.071 13.668 13.668 0 0 1 5.139-4.974 14.586 14.586 0 0 1 7.282-1.842 14.235 14.235 0 0 1 5.771 1.155 13.135 13.135 0 0 1 4.562 3.3l-4.617 4.672a6.908 6.908 0 0 0-2.5-1.759 8.315 8.315 0 0 0-3.215-.6 6.947 6.947 0 0 0-3.545.907 6.679 6.679 0 0 0-2.473 2.473 7.279 7.279 0 0 0-.906 3.71 7.468 7.468 0 0 0 .906 3.71 6.565 6.565 0 0 0 2.473 2.528 6.946 6.946 0 0 0 3.545.907 8.127 8.127 0 0 0 3.27-.632 6.882 6.882 0 0 0 2.5-1.841l4.672 4.671a13.92 13.92 0 0 1-4.672 3.353 14.24 14.24 0 0 1-5.772 1.147z",
    transform: "translate(-877.208 -475.301)",
    style: {
      fill: "#04051D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "E",
    d: "M1067.353 515.586a15.122 15.122 0 0 1-7.42-1.786 14.05 14.05 0 0 1-5.194-19.126 13.718 13.718 0 0 1 5.029-4.946 13.92 13.92 0 0 1 7.09-1.842 13.127 13.127 0 0 1 6.787 1.732 12.438 12.438 0 0 1 4.616 4.726 13.663 13.663 0 0 1 1.677 6.787 13.129 13.129 0 0 1-.083 1.457 14.326 14.326 0 0 1-.3 1.676l-22.313.055v-5.386l18.961-.055-2.913 2.253a10.565 10.565 0 0 0-.852-3.957 5.492 5.492 0 0 0-2.143-2.446 6.5 6.5 0 0 0-3.435-.852 7.1 7.1 0 0 0-3.738.962 6.329 6.329 0 0 0-2.445 2.693 10.231 10.231 0 0 0 .055 8.3 6.407 6.407 0 0 0 2.61 2.748 7.908 7.908 0 0 0 3.957.962 9.479 9.479 0 0 0 3.682-.687 7.724 7.724 0 0 0 2.858-2.061l4.232 4.231a12.3 12.3 0 0 1-4.7 3.408 15.521 15.521 0 0 1-6.018 1.154z",
    transform: "translate(-937.23 -475.301)",
    style: {
      fill: "#04051D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "D",
    d: "M1164.962 489.2a12.219 12.219 0 0 1-6.6-1.814 12.837 12.837 0 0 1-4.589-4.947 15.714 15.714 0 0 1 0-14.124 12.915 12.915 0 0 1 4.562-4.946 12.178 12.178 0 0 1 6.623-1.814 11.22 11.22 0 0 1 5.139 1.154 9.63 9.63 0 0 1 3.682 3.215 8.758 8.758 0 0 1 1.512 4.644v9.453a9.042 9.042 0 0 1-1.484 4.671 9.708 9.708 0 0 1-3.682 3.3 10.972 10.972 0 0 1-5.163 1.208zm1.209-6.65a6.76 6.76 0 0 0 3.545-.907 6.3 6.3 0 0 0 2.364-2.528 7.981 7.981 0 0 0 .851-3.765 7.864 7.864 0 0 0-.851-3.71 6.306 6.306 0 0 0-2.364-2.528 7.178 7.178 0 0 0-7.035.027 6.535 6.535 0 0 0-2.363 2.528 7.686 7.686 0 0 0-.852 3.682 7.965 7.965 0 0 0 .852 3.765 6.227 6.227 0 0 0 2.391 2.528 6.686 6.686 0 0 0 3.462.913zm13.52 6.1h-7.145v-7.145l1.154-6.485-1.209-6.376V448.92h7.2z",
    transform: "translate(-1004.391 -448.92)",
    style: {
      fill: "#04051D"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Raggruppa 4786",
    transform: "translate(0 1.224)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Quadrato",
    width: 16.957,
    height: 16.957,
    rx: 2,
    transform: "rotate(-90 19.692 -2.735)",
    style: {
      fill: "#ffc629"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Poligono 2671",
    d: "M709.537 454.568v21.287a1.471 1.471 0 0 0 1.471 1.471h21.287a1.857 1.857 0 0 1 1.857 1.857v11.055a1.857 1.857 0 0 1-1.857 1.857h-35.528a2 2 0 0 1-2-2v-35.527a1.857 1.857 0 0 1 1.857-1.857h11.056a1.857 1.857 0 0 1 1.857 1.857z",
    transform: "translate(-694.768 -452.711)",
    style: {
      fill: "#15e6e8"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Raggruppa 4787"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "S",
    d: "M1068.81 617.348a5.571 5.571 0 0 1-1.523-.207 5.155 5.155 0 0 1-1.345-.593 4.4 4.4 0 0 1-1.067-.939l1.384-1.384a3.229 3.229 0 0 0 1.137.86 3.533 3.533 0 0 0 1.453.286 2.248 2.248 0 0 0 1.108-.218.691.691 0 0 0 .375-.633.762.762 0 0 0-.356-.672 3.433 3.433 0 0 0-.92-.406q-.563-.167-1.186-.346a5.789 5.789 0 0 1-1.186-.484 2.557 2.557 0 0 1-.92-.84 2.454 2.454 0 0 1-.356-1.384 2.8 2.8 0 0 1 .425-1.562 2.767 2.767 0 0 1 1.206-1.009 4.477 4.477 0 0 1 1.868-.356 4.8 4.8 0 0 1 2.027.406 3.75 3.75 0 0 1 1.473 1.216l-1.384 1.385a2.759 2.759 0 0 0-.949-.772 2.8 2.8 0 0 0-1.226-.257 2.107 2.107 0 0 0-1.008.2.624.624 0 0 0-.357.574.681.681 0 0 0 .357.613 3.677 3.677 0 0 0 .919.376q.564.158 1.187.346a5.571 5.571 0 0 1 1.187.514 2.711 2.711 0 0 1 .919.87 2.543 2.543 0 0 1 .356 1.414 2.713 2.713 0 0 1-.969 2.195 3.97 3.97 0 0 1-2.629.807z",
    transform: "translate(-945.338 -556.255)",
    style: {
      fill: "#04051D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "p",
    d: "M1096.219 621.1v-13.441h2.175v2.551l-.375 2.314.375 2.293v6.283zm5.082-3.757a3.975 3.975 0 0 1-1.938-.465 3.45 3.45 0 0 1-1.335-1.275 3.515 3.515 0 0 1-.484-1.839v-2.724a3.462 3.462 0 0 1 .495-1.839 3.518 3.518 0 0 1 1.345-1.276 3.932 3.932 0 0 1 1.918-.465 4.231 4.231 0 0 1 2.323.662 4.756 4.756 0 0 1 1.642 1.78 5.53 5.53 0 0 1 0 5.022 4.671 4.671 0 0 1-1.642 1.77 4.278 4.278 0 0 1-2.325.654zm-.356-2.056a2.635 2.635 0 0 0 1.394-.366 2.571 2.571 0 0 0 .949-1.018 3.432 3.432 0 0 0 0-3.006 2.58 2.58 0 0 0-.949-1.018 2.641 2.641 0 0 0-1.394-.366 2.692 2.692 0 0 0-1.4.366 2.488 2.488 0 0 0-.949 1.018 3.527 3.527 0 0 0 0 3.006 2.479 2.479 0 0 0 .949 1.018 2.685 2.685 0 0 0 1.4.37z",
    transform: "translate(-966.559 -556.255)",
    style: {
      fill: "#04051D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "o",
    d: "M1137.242 617.348a4.863 4.863 0 0 1-2.511-.662 4.952 4.952 0 0 1-1.789-1.79 4.857 4.857 0 0 1-.662-2.511 4.754 4.754 0 0 1 .662-2.491 5.01 5.01 0 0 1 1.789-1.77 4.869 4.869 0 0 1 2.511-.662 4.961 4.961 0 0 1 2.531.653 4.9 4.9 0 0 1 1.789 1.77 4.811 4.811 0 0 1 .662 2.5 4.859 4.859 0 0 1-.662 2.511 4.916 4.916 0 0 1-4.32 2.452zm0-2.1a2.778 2.778 0 0 0 1.434-.366 2.532 2.532 0 0 0 .969-1.018 3.122 3.122 0 0 0 .346-1.483 2.934 2.934 0 0 0-.356-1.463 2.661 2.661 0 0 0-.969-1 2.933 2.933 0 0 0-2.837 0 2.564 2.564 0 0 0-.969 1 3 3 0 0 0-.346 1.463 3.113 3.113 0 0 0 .346 1.483 2.528 2.528 0 0 0 .969 1.018 2.738 2.738 0 0 0 1.413.37z",
    transform: "translate(-990.972 -556.255)",
    style: {
      fill: "#04051D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "r",
    d: "M1171.092 617.15v-9.491h2.175v9.491zm2.175-5.28-.751-.375a4.9 4.9 0 0 1 .8-2.917 2.783 2.783 0 0 1 2.422-1.117 2.9 2.9 0 0 1 2.353 1.087l-1.424 1.463a1.5 1.5 0 0 0-.573-.4 2.274 2.274 0 0 0-2.234.455 2.406 2.406 0 0 0-.593 1.804z",
    transform: "translate(-1017.249 -556.255)",
    style: {
      fill: "#04051D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "t",
    d: "M1196.008 601.762v-1.977h6.723v1.977zm2.274 7.514V595.83h2.175v13.446z",
    transform: "translate(-1034.118 -548.381)",
    style: {
      fill: "#04051D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "s",
    d: "M1224.921 617.348a5.573 5.573 0 0 1-1.523-.207 5.149 5.149 0 0 1-1.344-.593 4.418 4.418 0 0 1-1.068-.939l1.384-1.384a3.236 3.236 0 0 0 1.138.86 3.533 3.533 0 0 0 1.453.286 2.244 2.244 0 0 0 1.107-.218.691.691 0 0 0 .376-.633.761.761 0 0 0-.357-.672 3.434 3.434 0 0 0-.919-.406q-.564-.167-1.187-.346a5.82 5.82 0 0 1-1.187-.484 2.564 2.564 0 0 1-.919-.84 2.455 2.455 0 0 1-.355-1.384 2.8 2.8 0 0 1 .425-1.562 2.767 2.767 0 0 1 1.206-1.009 4.477 4.477 0 0 1 1.869-.356 4.8 4.8 0 0 1 2.027.406 3.756 3.756 0 0 1 1.473 1.216l-1.384 1.385a2.76 2.76 0 0 0-.949-.772 2.8 2.8 0 0 0-1.226-.257 2.108 2.108 0 0 0-1.009.2.625.625 0 0 0-.356.574.682.682 0 0 0 .356.613 3.675 3.675 0 0 0 .92.376q.563.158 1.186.346a5.541 5.541 0 0 1 1.187.514 2.707 2.707 0 0 1 .92.87 2.544 2.544 0 0 1 .356 1.414 2.713 2.713 0 0 1-.969 2.195 3.972 3.972 0 0 1-2.631.807z",
    transform: "translate(-1051.028 -556.255)",
    style: {
      fill: "#04051D"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAced);
export default __webpack_public_path__ + "static/media/Aced.f99a0ae508788239e64c0ba89287b86d.svg";
export { ForwardRef as ReactComponent };